import { EnderecoLocalTipo } from './../endereco-local-tipo/endereco-local-tipo.model';
import { Pais } from './../pais/pais.model';
import { Bairro } from '../bairro/bairro.model';
import { LogradouroCep } from '../logradouro-cep/logradouro-cep.model';

class EnderecoLocal {
    Id: string;
    Bairro: Bairro;
    LogradouroCEP: LogradouroCep;
    EnderecoLocalTipo: EnderecoLocalTipo;
    DescricaoEnderecoLocal: string;
    NumeroEndereco: number;

    constructor() {
        this.Bairro = new Bairro;
        this.LogradouroCEP = new LogradouroCep;
        this.EnderecoLocalTipo = new EnderecoLocalTipo;
    }
}

export class PessoaEndereco {
    Id: string;
    IdPessoa: string;
    EnderecoLocal: EnderecoLocal;
    Complemento: string;
    EnderecoTipo: string; // Instalação, Cobrança
    constructor() {
        this.EnderecoLocal = new EnderecoLocal;
    }
}

class Pessoa {
    Id: string;
    Nome: string;
    DtCadastro: Date;
    DtAlteracao: Date;
    PessoaEnderecos: PessoaEndereco[] = [];
    PessoaSpcz: string;
    PessoaTelefones: PessoaTelefone[] = [];
    PessoaEmails: PessoaEmail[] = [];
    PessoaContasCorrente: PessoaContaCorrente[] = [];

    constructor() {
        this.DtAlteracao = new Date;
        this.DtCadastro = new Date;
        //this.PessoaEnderecos = [];
        //this.PessoaEnderecos[0] = new PessoaEndereco;
    }
}

export class PessoaFisica extends Pessoa {
    PessoaFisicaSpcz: string;
    IdReligiao: number;
    IdProfissao: number;
    Rg: string;
    Cpf: string;
    DtNascimento: Date;
    EstadoCivil: string;
    Sexo: string;
    Emancipado: string;

    constructor() {
        super();
        this.DtNascimento = new Date;
    }
}

export class PessoaJuridica extends Pessoa {
    Cnpj: string;
    InscEstadual: string;
    RazaoSocial: string;
    PessoaJurificaSpcz: string;

    constructor() {
        super();
    }
}

class PessoaTelefone {
    Id: number; // No modelo o campo é "IDPessoaTelefone", utilizando "Id" por limitação do Mock-up
    //IdPessoa: number;  /* Nao utilizado no mockup, gravando PessoaTelefone dentro de Pessoa */
    NumeroTelefone: string;
    TelefoneTipo: string;
}

class PessoaEmail {
    Id: number; // No modelo o campo é "IDPessoaEmail", utilizando "Id" por limitação do Mock-up
    //IdPessoa: number;  /* Nao utilizado no mockup, gravando PessoaEmail dentro de Pessoa */
    Email: string;
    EmailTipo: string;
    Confirmado: string;
}

class PessoaContaCorrente {
    Id: number; // No modelo o campo é "IDPessoaContaCorrente", utilizando "Id" por limitação do Mock-up
    //IdPessoa: number;  /* Nao utilizado no mockup, gravando PessoaContaCorrente dentro de Pessoa */
    IdBancoAgencia: number;
    NumeroContaCorrente: string;
}


// WEBPACK FOOTER //
// ./src/app/pessoa/pessoa.model.ts